class HeaderMenuText extends HTMLElement {
  constructor() {
    super();
    const megaMenu = document.querySelector(".mega-menu");
    const headerMenuElement = document.querySelector("header-menu");
    headerMenuElement.style.display = "none";
    this.addEventListener("click", () => {
      const isOpen = megaMenu.hasAttribute("open");
      if (isOpen) {
        headerMenuElement.style.display = "none";
        megaMenu.removeAttribute("open");
        megaMenu.querySelector("summary").setAttribute("aria-expanded", false);
      } else {
        headerMenuElement.style.display = "block";
        megaMenu.setAttribute("open", "");
        megaMenu.querySelector("summary").setAttribute("aria-expanded", true);
      }
    });
  }
}
customElements.define("header-menu-text", HeaderMenuText);

class FlickityControls extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("flickity-controls", FlickityControls);

// var FlickityCarousel = class extends CustomHTMLElement {
//   constructor() {
//     super();
//     if (this.childElementCount === 1) {
//       return;
//     }
//     this.addEventListener("flickity:ready", this._preloadNextImage.bind(this));
//     this.addEventListener(
//       "flickity:slide-changed",
//       this._preloadNextImage.bind(this)
//     );
//     this._createFlickity();
//   }
//   async disconnectedCallback() {
//     if (this.flickity) {
//       const flickityInstance = await this.flickity;
//       flickityInstance.destroy();
//     }
//   }
//   get flickityConfig() {
//     return JSON.parse(this.getAttribute("flickity-config"));
//   }
//   get flickityInstance() {
//     return this.flickity;
//   }
//   async next() {
//     const flickityInstance = await this.flickityInstance;

//     //   console.log(flickityInstance,'Test',flickityInstance.next());
//     //    this.select(0);

//     flickityInstance.next();
//   }
//   async previous() {
//     (await this.flickityInstance).previous();
//   }
//   async select(indexOrSelector) {
//     (await this.flickityInstance).selectCell(indexOrSelector);
//   }
//   async setDraggable(draggable) {
//     const flickityInstance = await this.flickity;
//     flickityInstance.options.draggable = draggable;
//     flickityInstance.updateDraggable();
//   }
//   async reload() {
//     const flickityInstance = await this.flickity;
//     flickityInstance.destroy();
//     if (this.flickityConfig["cellSelector"]) {
//       Array.from(this.children)
//         .sort((a, b) =>
//           parseInt(a.getAttribute("data-original-position")) >
//           parseInt(b.getAttribute("data-original-position"))
//             ? 1
//             : -1
//         )
//         .forEach((node) => this.appendChild(node));
//     }
//     this._createFlickity();
//   }
//   async _createFlickity() {
//     this.flickity = new Promise(async (resolve) => {
//       await LibraryLoader.load("flickity");
//       await this.untilVisible({ rootMargin: "400px", threshold: 0 });
//       const flickityInstance = new window.ThemeFlickity(this, {
//         ...this.flickityConfig,
//         ...{
//           rightToLeft: window.themeVariables.settings.direction === "rtl",
//           accessibility: MediaFeatures.supportsHover(),
//           // Flickity cause the carousel to scroll when focused, which is annoying on mobile
//           on: {
//             ready: (event) => triggerEvent(this, "flickity:ready", event),
//             change: (event) =>
//               triggerEvent(this, "flickity:slide-changed", event),
//             settle: (event) =>
//               triggerEvent(this, "flickity:slide-settled", event),
//           },
//         },
//       });
//       resolve(flickityInstance);
//     });
//     if (this.hasAttribute("click-nav")) {
//       const flickityInstance = await this.flickityInstance;
//       flickityInstance.on("staticClick", this._onStaticClick.bind(this));
//       this.addEventListener("mousemove", this._onMouseMove.bind(this));
//     }
//   }
//   /**
//    * If the "click-nav" option is passed, desktop device can switch from one slide to the other
//    */
//   async _onStaticClick(event, pointer, cellElement) {
//     const flickityInstance = await this.flickityInstance,
//       isVideoOrModelType =
//         flickityInstance.selectedElement.hasAttribute("data-media-type") &&
//         ["video", "external_video", "model"].includes(
//           flickityInstance.selectedElement.getAttribute("data-media-type")
//         );
//     if (
//       !cellElement ||
//       isVideoOrModelType ||
//       window.matchMedia(window.themeVariables.breakpoints.phone).matches
//     ) {
//       return;
//     }
//     const flickityViewport = flickityInstance.viewport,
//       boundingRect = flickityViewport.getBoundingClientRect(),
//       halfEdge = Math.floor(boundingRect.right - boundingRect.width / 2);
//     if (pointer.clientX > halfEdge) {
//       flickityInstance.next();
//     } else {
//       flickityInstance.previous();
//     }
//   }
//   /**
//    * Add the class "is-hovering-right" or "is-hovering-left" depending on the part we're hovering
//    */
//   async _onMouseMove(event) {
//     const flickityInstance = await this.flickityInstance,
//       isVideoOrModelType =
//         flickityInstance.selectedElement.hasAttribute("data-media-type") &&
//         ["video", "external_video", "model"].includes(
//           flickityInstance.selectedElement.getAttribute("data-media-type")
//         );
//     this.classList.toggle(
//       "is-hovering-right",
//       event.offsetX > this.clientWidth / 2 && !isVideoOrModelType
//     );
//     this.classList.toggle(
//       "is-hovering-left",
//       event.offsetX <= this.clientWidth / 2 && !isVideoOrModelType
//     );
//   }
//   /**
//    * To give a feeling of faster browsing, we always preload the next image once we settle on a slide
//    */
//   async _preloadNextImage() {
//     const flickityInstance = await this.flickity;
//     //  console.log(flickityInstance);
//     if (flickityInstance.selectedElement.nextElementSibling) {
//       flickityInstance.selectedElement.nextElementSibling
//         .querySelector("img")
//         ?.setAttribute("loading", "eager");
//     }
//   }
// };
// window.customElements.define("flickity-carousel", FlickityCarousel);

// var FlickityControls = class extends CustomHTMLElement {
//   async connectedCallback() {
//     this.flickityCarousel.addEventListener(
//       "flickity:ready",
//       this._onSlideChanged.bind(this, false)
//     );
//     this.flickityCarousel.addEventListener(
//       "flickity:slide-changed",
//       this._onSlideChanged.bind(this, true)
//     );
//     this.delegate.on("click", '[data-action="prev"]', () =>
//       this.flickityCarousel.previous()
//     );
//     this.delegate.on("click", '[data-action="next"]', () =>
//       this.flickityCarousel.next()
//     );
//     this.delegate.on("click", '[data-action="select"]', (event, target) =>
//       this.flickityCarousel.select(`#${target.getAttribute("aria-controls")}`)
//     );
//   }
//   get flickityCarousel() {
//     return (this._flickityCarousel =
//       this._flickityCarousel ||
//       document.getElementById(this.getAttribute("controls")));
//   }
//   async _onSlideChanged(animate = true) {
//     let flickityInstance = await this.flickityCarousel.flickityInstance;
//     let selectedItem = this.querySelectorAll(
//       `[aria-controls="${flickityInstance.selectedElement.id}"]`
//     );
//     let activeItems = Array.from(selectedItem);
//     let w = window.innerWidth;

//     //  console.log(activeItems,flickityInstance);
//     //  activeItems = activeItems.nextElementSibling;
//     activeItems.forEach((activeItem) => {
//       //  const hasClass = activeItem.classList.contains('highlight');
//       let nextElement = activeItem.nextElementSibling;
//       //   console.log(nextElement,'nextElement');
//       if (w >= 1000) {
//         if (nextElement) {
//           activeItem = nextElement;
//         } else {
//           // activeItem = nextElement;
//           const parentElement = activeItem.parentNode;
//           //     console.log(parentElement);
//           activeItem = parentElement.firstElementChild;
//         }
//       }
//       activeItem.setAttribute("aria-current", "true");
//       //  console.log(activeItem,'activeItem');

//       getSiblings(activeItem).forEach((sibling) =>
//         sibling.removeAttribute("aria-current")
//       );
//       requestAnimationFrame(() => {
//         if (activeItem.offsetParent && activeItem.offsetParent !== this) {
//           const windowHalfHeight = activeItem.offsetParent.clientHeight / 2,
//             windowHalfWidth = activeItem.offsetParent.clientWidth / 2;
//           activeItem.offsetParent.scrollTo({
//             behavior: animate ? "smooth" : "auto",
//             top:
//               activeItem.offsetTop -
//               windowHalfHeight +
//               activeItem.clientHeight / 2,
//             left:
//               activeItem.offsetLeft -
//               windowHalfWidth +
//               activeItem.clientWidth / 2,
//           });
//         }
//       });
//     });
//   }
// };
// window.customElements.define("flickity-controls", FlickityControls);
